/** 启用停用状态 */
export enum TEOrderStatus {
  Success = 'Success',
  Pending = 'Pending',
  NotAccepted = 'NotAccepted',
  Cancel = 'Cancel',
  Timeout = 'Timeout',
  Paying = 'Paying',
}

/** 订单类型 */
export enum TEOrdersType {
  dc = 'dc',
  cz = 'cz',
  goods = 'goods',
  mall = 'mall',
}

/** 订单退款类型 */
export enum TEOrdersRefundStatus {
  /** 退款成功 */
  Success = 'Success',
  /** 发起退款 */
  Pending = 'Pending',
  /** 取消退款 */
  // Cancel = 'Cancel',
  /** 已拒绝退款 */
  Reject = 'Reject',
  /** 退款超时 */
  Timeout = 'Timeout'
}
